// src/components/Footer.jsx
import React from 'react';
import SiteFooter from './layout/SiteFooter';

/**
 * Unified ByOnco Site Footer across all hub and spoke directory pages.
 * Renders the clean, balanced 5-column deep botanical footer.
 */
export default function Footer() {
  return <SiteFooter />;
}
